import React from 'react';
import { SdmDialog, SdmTypography } from 'components';

function InfoDialog({
  onClose,
  i18n,
  img = '/themes/custom/sdm/images/mail/breakout-room-img.jpg',
}) {
  const renderTitle = () => {
    return (
      <div style={{ width: '100%', marginTop: 16 }}>
        <SdmTypography
          variant={'h1'}
          style={{ textAlign: 'center', marginTop: 20, marginBottom: 0 }}
        >
          {i18n.title}
        </SdmTypography>
      </div>
    );
  };

  return (
    <SdmDialog
      open
      onClose={onClose}
      title={renderTitle()}
      agreeText={i18n.agree}
      onAgree={onClose}
      paperStyle={{
        borderRadius: 15,
        paddingBottom: 16,
        margin: 0,
      }}
      closeIconContainerStyle={{
        top: 15,
        right: 20,
        transform: 'scale(1.5)',
      }}
      actionContainerStyle={{ justifyContent: 'center' }}
      actionStyle={{ height: 40, width: 158, margin: 0 }}
      actionTextStyle={{ fontSize: 20 }}
      titleStyle={{ padding: 0 }}
      contentStyle={{
        padding: 8,
        flex: 'none',
        margin: '0 auto',
      }}
      showTitleDivider={false}
      handleBody={false}
      maxWidth={false}
    >
      <div style={{ display: 'flex', width: '100%', justifyContent: 'center' }}>
        <img
          style={{
            height: '100%',
            maxWidth: '70%',
            objectFit: 'cover',
          }}
          src={img}
        />
      </div>
    </SdmDialog>
  );
}

export default InfoDialog;
